import type { UseFormRegister, FieldValues, Path } from 'react-hook-form';

interface UserCustomFieldToggleProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  register: UseFormRegister<T>;
  className?: string;
}

export function UserCustomFieldToggle<T extends FieldValues>({
  name,
  label,
  register,
  className = '',
}: UserCustomFieldToggleProps<T>) {
  return (
    <label className={`flex cursor-pointer items-center gap-3 ${className}`}>
      <span className="relative inline-block h-6 w-11 shrink-0">
        <input type="checkbox" className="peer sr-only" {...register(name)} />
        <span
          className="block h-6 w-11 rounded-full bg-secondary-200 transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-dash-secondary/20 peer-checked:bg-dash-primary"
          aria-hidden="true"
        />
        <span
          className="pointer-events-none absolute left-0.5 top-0.5 block h-5 w-5 rounded-full bg-white shadow-sm transition-transform peer-checked:translate-x-5"
          aria-hidden="true"
        />
      </span>
      <span className="text-sm font-medium text-dash-on-surface transition-colors group-hover:text-dash-primary">{label}</span>
    </label>
  );
}
